module.exports = __webpack_public_path__ + "static/media/privacy-policy.168d1d27.md";